// extracted by mini-css-extract-plugin
module.exports = {"LayoutFixed":"LayoutFixed_LayoutFixed__3WazP","main":"LayoutFixed_main__Mm4RH","blur":"LayoutFixed_blur__2oVKb"};